
var guidUtil = require('../../../utils/guid/guidUtil');
var menuUtil = require('../../../utils/domain/menu/menuUtil');
var viewUtil = require('../../../utils/view/viewUtil');
var dateUtil = require('../../../utils/dateUtil/dateUtil');
var saleCommonUtility = require('../../../utils/domain/sales/saleCommonUtility');
var saleInitializer = require('../../../utils/domain/sales/saleInitializer');
var saleTimingsCalculator = require('../../../utils/domain/sales/saleTimingsCalculator');
var staffUtility = require('../../../utils/domain/staff/staffUtility');
var cashFloatUtil = require('../../../utils/domain/cashFloatUtil');
var constants = require('../../../utils/domain/constants');
var saleCalculator = require('../../../utils/domain/sales/saleCalculator');
var commonUtility = require('../../../utils/domain/commonUtility');
var controlSettingsUtils = require('../../../utils/domain/settings/controlSettingsUtils');
var stateManager = require('../../../utils/state/stateManager.js');
var saleContextAction = require('../../../utils/state/actions/sales/saleContextAction');
var staffLoginAction = require('../../../utils/state/actions/staffLogin/staffLoginAction.js');
var todaysSalesUpdatedDateTimeAction = require('../../../utils/state/actions/sales/todaysSalesUpdatedDateTimeAction');
const navigationButtonsIds = require('../../Navigation/navigationButtonsIds');
var navigationPageAction = require('../../../utils/state/actions/views/navigationPage/navigationPageAction');
var stringUtil = require('../../../utils/string/stringUtil');
var validator = require('../../../utils/validator/validator.js');
const translator = require('../../../utils/translator/translator');
const salesLoader = require('../../../utils/domain/sales/salesLoader');
const orderNumberFountain = require('../../../utils/domain/orderNumberFountain');
const shellAPIServer = require('../../../utils/api/shellAPIServer');
const rmsApiProxyRetry = require('../../../utils/api/rmsApiProxyRetry');
const jobsServer = require('../../../utils/jobs/jobsServer');
const salePublisher = require('../../../utils/domain/sales/salePublisher');


export function getCurrentSaleContext()
{
    return stateManager.getStore().getState().saleContext;
}

export function instantiateSaleContext(sale, isExistingSale)
{
    if (isExistingSale)
    {
        sale = cloneSale(sale);
    }

    let saleContext = {};
    saleContext.sale = sale;
    saleContext.isExistingSale = isExistingSale;
    saleContext.saleChangedDateTime = Date.now();
    saleContext.menuChangedDateTime = Date.now();
    saleContext.selectedStorefrontId = sale.storefrontId;
    saleContext.requirePublishing = false;
    saleContext.changesMadeToPayment = false;
    saleContext.selectedItems = [];
    saleContext.wasOriginallyHold = stringUtil.areStringSame(sale.saleType, constants.SaleTypeHold);
    saleContext.menuContexts = new Map();
    saleContext.customerContext = null;

    saleContext.primaryMenu = menuUtil.getPrimaryMenu(sale.propertyId, sale.storefrontId, sale.venueCode, sale.dispatchType);
    
    if (saleContext.primaryMenu == null)
    {
         viewUtil.showCriticalAlert(translator.getLabel("failed_to_find_default_menu_for_the_sale"));
         return null;
    }

    saleContext.selectedCategory = saleContext.primaryMenu.categories.find(c => c.enabled);
    return saleContext;
}

export function createAndDispatchSaleContext(sale, isExistingSale)
{
     let saleContext = instantiateSaleContext(sale, isExistingSale);
     if (saleContext == null)
        return saleContext;

     stateManager.getStore().dispatch(saleContextAction.createAction(saleContext));
     return saleContext;
}

export function openSale(sale, isExistingSale)
{
    if (createAndDispatchSaleContext(sale, isExistingSale) == null)
        return;

     let navigationPagePayload  = {}
     navigationPagePayload.id = navigationButtonsIds.order;
     stateManager.getStore().dispatch(navigationPageAction.createAction(navigationPagePayload));
     shellAPIServer.displaySale(sale, commonUtility.getPropertyResolvedLocationSettings())
}

export function openSaleContext(saleContext)
{
    stateManager.getStore().dispatch(saleContextAction.createAction(saleContext));

    let navigationPagePayload  = {}
    navigationPagePayload.id = navigationButtonsIds.order;
    stateManager.getStore().dispatch(navigationPageAction.createAction(navigationPagePayload));
    shellAPIServer.displaySale(saleContext.sale, commonUtility.getPropertyResolvedLocationSettings())
}


export function closeSale()
{
     stateManager.getStore().dispatch(navigationPageAction.createAction(null));
     stateManager.getStore().dispatch(saleContextAction.createAction(null));
     shellAPIServer.closeSale();
    
     if (controlSettingsUtils.getLogoutAfterEachOrder())
     {
        stateManager.getStore().dispatch(staffLoginAction.createAction(null));
     }
}


export function changeSaleContextMenu(storefrontId)
{
    let saleContext = getCurrentSaleContext();
    let sale = saleContext.sale;
    
    saleContext.selectedStorefrontId = storefrontId;
    saleContext.primaryMenu = menuUtil.getPrimaryMenu(sale.propertyId, storefrontId, sale.venueCode, sale.dispatchType);
    saleContext.selectedCategory = saleContext.primaryMenu.categories.find(c => c.enabled);
    raiseSaleContextMenuChangeEvent();
}

export function replaceSaleWithLatestSale()
{
    let saleContext = getCurrentSaleContext();
    if (saleContext == null || saleContext.sale == null || saleContext.changesMadeToPayment)
        return;

    let todaysSales = stateManager.getStore().getState().todaySales;
    let existingSale = todaysSales.find (s => stringUtil.areStringSame(s.id, saleContext.sale.id));
    if (existingSale == null || dateUtil.isBefore(existingSale.lastUpdatedDateTime, saleContext.sale.lastUpdatedDateTime))
        return;

    existingSale = cloneSale(existingSale);

    saleContext.sale = existingSale;
    saleContext.isExistingSale = true;
    saleContext.saleChangedDateTime = Date.now();
    saleContext.menuChangedDateTime = Date.now();
    saleContext.selectedStorefrontId = existingSale.storefrontId;
    saleContext.requirePublishing = false;
    saleContext.changesMadeToPayment = false;
    saleContext.selectedItems = [];
    saleContext.wasOriginallyHold = stringUtil.areStringSame(existingSale.saleType, constants.SaleTypeHold);
    saleContext.menuContexts = new Map();
    saleContext.customerContext = null;

    raiseSaleContextSaleChangeEvent(false, false, false);
}


export function raiseSaleContextMenuChangeEvent()
{
    let saleContext = getCurrentSaleContext();
    saleContext.menuChangedDateTime = Date.now();
    stateManager.getStore().dispatch(saleContextAction.createAction(saleContext));
}

export function raiseSaleContextSaleChangeEvent(changesImpactingPrice, requirePublishing = true, changesMadeToPayment = false)
{
    let saleContext = getCurrentSaleContext();
    let sale = saleContext.sale;

    if (changesImpactingPrice)
        updateSaleAfterChange(sale);

    if (requirePublishing)
        saleContext.requirePublishing = true;

    if (changesMadeToPayment)
        saleContext.changesMadeToPayment = true;
   
    saleContext.saleChangedDateTime = Date.now();
    stateManager.getStore().dispatch(saleContextAction.createAction(saleContext));
    shellAPIServer.displaySale(saleContext.sale, commonUtility.getPropertyResolvedLocationSettings())
}


export function setSaleItemMenuContext (saleItem, menuContext, isOpenItem = false)
{
    let payload = {};
    payload.isOpenItem = isOpenItem;
    payload.menuContext = menuContext;

    getCurrentSaleContext().menuContexts[saleItem.id] = payload;
}

export function getSaleItemMenuContext (saleItem)
{
    let payload = getCurrentSaleContext().menuContexts[saleItem.id];
    if (payload == null)
        return null;

    return payload.menuContext;
}

export function getSaleItemMenuContextPayload (saleItem)
{
    return getCurrentSaleContext().menuContexts[saleItem.id];
}

export function prepareSaleForPublishing(saleContext)
{
    let sale = saleContext.sale;
    sale.lastUpdatedDateTime = dateUtil.getNow();
    sale.floatSessionId = cashFloatUtil.getActiveFloatSessionId();

    if (stringUtil.isStringNullOrEmpty(sale.dateTime) || saleContext.wasOriginallyHold)
    {
        sale.dateTime = sale.lastUpdatedDateTime;
    }

    if (stringUtil.isStringNullOrEmpty(sale.originalPlannedDispatchDateTime) || saleContext.wasOriginallyHold)
    {
        sale.originalPlannedDispatchDateTime = saleTimingsCalculator.calculateChannelDispatchTime(sale);
    }

    if (stringUtil.isStringNullOrEmpty(sale.currentPlannedDispatchDateTime) || saleContext.wasOriginallyHold)
    {
        sale.currentPlannedDispatchDateTime = sale.originalPlannedDispatchDateTime;
    }

    if (!stringUtil.isStringNullOrEmpty(saleContext.updatedDispatchDateTime))
    {
        sale.currentPlannedDispatchDateTime = saleContext.updatedDispatchDateTime;
    }

    saleContext.updatedDispatchDateTime = null;
    saleContext.wasOriginallyHold = false;
}

export function publishAndCloseSale(saleContext)
{
    if (saleContext.requirePublishing)
    {
        prepareSaleForPublishing(saleContext);

        jobsServer.addJob(guidUtil.generateGuid(), "Sales.Publishing", async ()=>
        {
              let attendanceResourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/accounts/sales`;
              await rmsApiProxyRetry.post(attendanceResourceUrl, saleContext.sale);
        })

        if (!saleContext.isExistingSale)
        {
            orderNumberFountain.incrementOrderNumber();
        }

        if (saleCommonUtility.isTodaysBusinessDateSale(saleContext.sale))
        {
            let sales = stateManager.getStore().getState().todaySales;
            sales = sales.filter(s => !stringUtil.areStringSame(s.id, saleContext.sale.id));
            sales.push(saleContext.sale);
            salesLoader.initializeSale(saleContext.sale);
            stateManager.getStore().getState().todaySales = sales;
            stateManager.getStore().dispatch(todaysSalesUpdatedDateTimeAction.createAction());
        }

        salePublisher.publishSaleInChannel(saleContext.sale);
    }

    closeSale();
    
}


function updateSaleAfterChange(sale)
{
    updateServiceCharges(sale);
    updateDiscounts(sale);
    updateVenuePaidSale(sale);
}

function cloneSale(sale)
{
    sale = JSON.parse(JSON.stringify(sale));
    delete sale.dueDateTime;
    delete sale.activationDateTime;
    return sale;
}


function updateServiceCharges(sale)
{
     var serviceChargesPercentage = saleCommonUtility.getSaleServiceChargePercentage(sale);
     if (serviceChargesPercentage == null || serviceChargesPercentage <= constants.numericThresholdValue)
         return;
     
     var totalOrderPrice = saleCalculator.calculateTotalOrderPrice(sale);
     if (totalOrderPrice <= constants.numericThresholdValue)
     {
         sale.charges = sale.charges.filter(c => c.type != constants.ChargesTypes.VenueServiceCharges);
         return;
     }
 
     var existingServiceCharge = null;
     sale.charges.forEach(charge =>
     {
         if (charge.type == constants.ChargesTypes.VenueServiceCharges)
         {
             existingServiceCharge = charge;
         }
     });
 
     if (existingServiceCharge != null)
     {
         if (existingServiceCharge.amount <= constants.numericThresholdValue)        //indicates it is removed or zeroed by staff.
             return;
 
         existingServiceCharge.amount = totalOrderPrice * serviceChargesPercentage;
     }
     else
     {
         var serviceCharge = {};
         serviceCharge.type = constants.ChargesTypes.VenueServiceCharges;
         serviceCharge.amount = totalOrderPrice * serviceChargesPercentage;
         serviceCharge.vat = 0;
         serviceCharge.notes = null;
         sale.charges.push(serviceCharge);
     }
}

function updateDiscounts (sale)
{
    if (sale.discounts == null || sale.discounts.length <= 0)
        return 0.0;

    var originalDiscounts = sale.discounts.filter(d => d.value != null && 
                                                  validator.isNumeric(d.value) && 
                                                  !stringUtil.areStringSame(d.discountOfferType, constants.DiscountOfferTypes.Voucher));
    
    /*
        From this point onwards there should be no discount where discount type is voucher.
        Voucher based discounting cannot be handled by the client, so we always resets it if there is any change in sale.
        For non-voucher based discounting, client will try to handle it if all required information is available.
    */
    
    sale.discounts = [];

    for(const discount of originalDiscounts)
    {
        if (stringUtil.isStringNullOrEmpty(discount.saleItemId))
        {
            if (updateOrderLevelDiscount(discount, sale))
                sale.discounts.push(discount);
        }
        else
        {
            if (updateItemLevelDiscount(discount, sale))
                sale.discounts.push(discount);
        }
    }
}

function updateOrderLevelDiscount(discount, sale)
{
    var applicableTotalSaleValue = saleCalculator.calculateTotalSalePriceForSakeOfApplyingDiscounts(sale, discount.type);
        
    discount.amount = 0;
    if(applicableTotalSaleValue < discount.minimumOrderAmount) 
    {
        const errorMessage = translator.getLabel("total_amount_is_less_than_the_minimum_order_amount_of_the_discount_offer");
        viewUtil.showErrorAlert(errorMessage);
        return false;
    }
    
    if(stringUtil.areStringSame(discount.discountOfferType, constants.DiscountOfferTypes.Fixed))
        discount.amount = saleCalculator.roundNumericValue(returnLesserValue(applicableTotalSaleValue, discount.value));
    
    else if(stringUtil.areStringSame(discount.discountOfferType, constants.DiscountOfferTypes.Percentage))
        discount.amount = saleCalculator.roundNumericValue(applicableTotalSaleValue * (discount.value / 100));

    return discount.amount > constants.numericThresholdValue;
}

function updateItemLevelDiscount(discount, sale)
{
    var targetItem = findSaleItemInSaleById(sale, discount.saleItemId);
    if (targetItem == null)
        return false;

    
    var applicableTotalSaleValue = saleCalculator.calculateTotalSalePriceForSakeOfApplyingDiscounts(sale, discount.type);
    if(applicableTotalSaleValue < discount.minimumOrderAmount) 
    {
        const errorMessage = translator.getLabel("total_amount_is_less_than_the_minimum_order_amount_of_the_discount_offer");
        viewUtil.showErrorAlert(errorMessage);
        return false;
    }

    applicableTotalSaleValue = saleCalculator.calculateTotalSalePriceOfItemForSakeOfApplyingDiscounts(targetItem, discount.type);

    if(stringUtil.areStringSame(discount.discountOfferType, constants.DiscountOfferTypes.Fixed))
        discount.amount = saleCalculator.roundNumericValue(returnLesserValue(applicableTotalSaleValue, discount.value), 2);
    
    else if(stringUtil.areStringSame(discount.discountOfferType, constants.DiscountOfferTypes.Percentage))
        discount.amount = saleCalculator.roundNumericValue(applicableTotalSaleValue * (discount.value / 100), 2);

    return discount.amount > constants.numericThresholdValue;
}

function findSaleItemInSaleById (sale, itemId)
{
    for (var index = 0; index < sale.saleItems.length; index++)
    {
        var rootItem = sale.saleItems[index];
        if (stringUtil.areStringSame(rootItem.id, itemId))
            return rootItem;
    }

    return  null;
}


function updateVenuePaidSale (sale)
{
     if (sale.paymentMethod == constants.PaymentMethodVenuePaid && sale.venueCode != constants.VenueCodeMobileApp)
     {
         sale.receiptLines = sale.receiptLines.filter(r => r.type != constants.ReceiptLineTypeCharge || r.paymentMethod != constants.PaymentMethodVenuePaid);
        
         var netSaleAmount = saleCalculator.calculateTotalNetSalePrice(sale);
         if (netSaleAmount > 0)
         {
             if (sale.saleType == constants.SaleTypeStaffMeal)
             {
                 var limit = staffUtility.inferStaffMealLimit();
                 if (netSaleAmount > limit)
                     netSaleAmount = limit
             }
 
             if (sale.saleType == constants.SaleTypeGuestsMeal)
             {
                 var limit = staffUtility.inferStaffGuestMealLimit();
                 if (netSaleAmount > limit)
                     netSaleAmount = limit
             }
 
             if (sale.saleType == constants.SaleTypeFreebiesMeal)
             {
                 var limit = staffUtility.inferStaffFreebiesMealLimit();
                 if (netSaleAmount > limit)
                     netSaleAmount = limit
             }
 
             if (netSaleAmount > constants.numericThresholdValue)
             {
                 var receiptLine = saleInitializer.createReceiptLine(constants.ReceiptLineTypeCharge, netSaleAmount, constants.PaymentMethodVenuePaid);
                 sale.receiptLines.push(receiptLine);
             }
             
         }
         sale.paidAmount = netSaleAmount;
     }
}

function returnLesserValue(value1, value2)
{
    if(value1 > value2) return value2;
    return value1;
}